import { animate, group, query, style, transition, trigger } from '@angular/animations';
import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { BehaviorSubject } from 'rxjs';
import { skip } from 'rxjs/operators';
import { TopbarStateService } from './../../services/topbar-state.service';

@Component({
  selector: 'app-main-menu',
  templateUrl: './main-menu.component.html',
  styleUrls: ['./main-menu.component.less'],
  animations: [
    trigger(
      'outAnimation',
      [
        transition(
          ':leave',
          [
            animate('0.3s ease-in-out',
              style({ opacity: 0 }))
          ]
        )
      ]
    ),
    trigger(
      'menuAnimation',
      [

        transition(
          ':enter',
          [
            query(".buttons, .character-wrapper", [style({ opacity: 0 })]),
            style({ bottom: "100vh", top: "-100vh", opacity: 0 }),
            animate('0.4s ease-in-out',
              style({ bottom: "7vh", top: "16vh", opacity: 1 })),
            animate('0.3s ease-in-out',
              style({ bottom: "10vh", top: "13vh", opacity: 1 })),
            group([
              query('.buttons',
                [style({ bottom: "-40vh", opacity: 0.6 }),
                animate('0.3s ease-in-out',
                  style({ bottom: "5vh", opacity: 1 })),
                animate('0.2s ease-out',
                  style({ bottom: "3vh" }))
                ]),
              query('.character-wrapper',
                [
                  animate('0.5s ease-out',
                    style({ opacity: 1 }))
                ]),

            ]),

          ]
        ),
        transition(
          ':leave',
          [
            animate('0.2s ease-in-out',
              style({ bottom: "7vh", top: "16vh", opacity: 1 })),
            animate('0.8s ease-in-out',
              style({ bottom: "100vh", top: "-100vh", opacity: 0 }))
          ]
        )
      ]
    ),
  ]
})
export class MainMenuComponent implements OnInit {
  public menuIn: boolean = true;
  public menuLeaveObs: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(null);
  constructor(private topBarState: TopbarStateService,
    private router: Router) {

  }
  public buttons = [{
    text: "RANDOM",
    action: () => {
      this.menuIn = false;
      this.menuLeaveObs.pipe(skip(1)).subscribe(r => {
        this.router.navigate(["code-game"]);
      });
    }
  },

  {
    text: "MY DOORS", action: () => {
      this.menuIn = false;
      this.menuLeaveObs.pipe(skip(1)).subscribe(r => {
        this.router.navigate(["my-doors"]);
      });
    }
  },
  {
    text: "PICK A DOOR", action: () => {
      this.menuIn = false;
      this.menuLeaveObs.pipe(skip(1)).subscribe(r => {
        this.router.navigate(["level-selector"]);
      });
    }
  },
  {
    text: "STORE", action: () => { console.log("TIENDA") }
  },
  {
    text: "EXIT", action: () => { console.log("SALIR") }
  },]

  ngOnInit(): void {
    this.topBarState.state = true;
  }
  public menuLeaves() {
    this.menuLeaveObs.next(true);
  }

}
